<template>
  <LcBadge class="bg-accent-win-win-bold" icon="winning">
    {{ $t('myorders.status.winning') }}
  </LcBadge>
</template>
